import { HttpContextToken, HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { catchError, from, switchMap, throwError } from 'rxjs';

export const NO_AUTH_CONTEXT = new HttpContextToken<boolean>(() => false);
export const SKIP_SIGN_OUT_ON_401_CONTEXT = new HttpContextToken<boolean>(() => false);

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  if (req.context.get(NO_AUTH_CONTEXT)) {
    return next(req);
  }

  return from(authService.getIdToken()).pipe(
    switchMap((token) => {
      if (!token) {
        return next(req);
      }

      const newReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });

      return next(newReq);
    }),
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 && !req.context.get(SKIP_SIGN_OUT_ON_401_CONTEXT)) {
        return from(authService.signOut()).pipe(switchMap(() => throwError(() => error)));
      }

      return throwError(() => error);
    })
  );
};
